import { Component } from "react"

/* Portal */
import ReactDOM from "react-dom"

/* Redux */
import { connect } from "react-redux"
import { store } from "../store"

/* SweetAlert */
import Swal from "sweetalert2"

/* Translate */
import { t } from "../translates/translate"

/* Timezone helpers */
import { OFFSETS, deviceOffsetHours, offsetLabel, offsetShort, timeAt } from "../helpers/timezone"


/* Clock Icon */
const Clock = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </svg>
)


/* Widget Timezone Switcher */
class TimezoneSwitcher extends Component {

    constructor() {
        super()
        this.state = { visible: false, tick: 0 }
    }

    componentDidMount = () => {
        /* Refresh the displayed clocks every 15s */
        this._interval = setInterval(() => this.setState((s) => ({ tick: s.tick + 1 })), 15000)
        this._confirmFirstVisit()
    }

    componentWillUnmount = () => {
        if (this._interval) clearInterval(this._interval)
    }

    /* Ask on the very first visit whether the detected timezone is correct */
    _confirmFirstVisit = () => {
        if (localStorage.getItem("timezone") !== null) return
        this._openConfirm()
    }

    _openConfirm = () => {

        const device = deviceOffsetHours()
        /* Читаем язык из стора напрямую — this.props.language ещё не обновлён после только что сделанного setLanguage */
        const language = store.getState().language

        Swal.fire({
            title: t("timezone.confirmTitle"),
            html: `
                <div class="tz-confirm-lang">
                    <span class="menu-tz-lang-item ${language === "ru" ? "active" : ""}" data-lang="ru">RU</span>
                    <span class="menu-tz-lang-item ${language === "en" ? "active" : ""}" data-lang="en">EN</span>
                </div>
                <div class="tz-confirm">
                    <div class="tz-confirm-zone">${offsetLabel(device)}</div>
                    <div class="tz-confirm-time">${timeAt(device)}</div>
                    <div class="tz-confirm-hint">${t("timezone.confirmText")}</div>
                </div>
            `,
            icon: "question",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: "#03a9f4",
            confirmButtonText: t("timezone.yes"),
            cancelButtonText: t("timezone.change"),
            didOpen: () => {
                const popup = Swal.getPopup()
                popup.querySelectorAll(".tz-confirm-lang .menu-tz-lang-item").forEach((el) => {
                    el.addEventListener("click", () => {
                        const lang = el.getAttribute("data-lang")
                        if (lang !== store.getState().language) {
                            this.props.setLanguage(lang)
                            Swal.close()
                            this._openConfirm()
                        }
                    })
                })
            },
        }).then((result) => {
            if (result.isConfirmed) {
                /* Persist the detected offset (value == current default → no reload needed) */
                this.props.setTimezone(device)
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                this.setState({ visible: true })
            }
        })
    }

    /* Apply a chosen offset and reload so every page refetches with the new timezone */
    _apply = (hours) => {

        const { timezone, setTimezone } = this.props

        this.setState({ visible: false })

        if (hours === timezone) return

        setTimezone(hours)
        window.location.reload()
    }

    render = () => {

        const { timezone, minimized, language, setLanguage } = this.props
        const { visible } = this.state

        return (
            <div className="menu-tz">

                <div className="menu-tz-btn" onClick={() => this.setState({ visible: true })}>
                    <Clock />
                    <span>{minimized ? offsetShort(timezone) : offsetLabel(timezone)}</span>
                </div>

                {visible && ReactDOM.createPortal(
                    <div className="menu-tz-overlay" onClick={() => this.setState({ visible: false })}>
                        <div className="menu-tz-modal" onClick={(e) => e.stopPropagation()}>

                            <div className="menu-tz-lang">
                                <span className={`menu-tz-lang-item ${language === "ru" ? "active" : ""}`} onClick={() => setLanguage("ru")}>RU</span>
                                <span className={`menu-tz-lang-item ${language === "en" ? "active" : ""}`} onClick={() => setLanguage("en")}>EN</span>
                            </div>

                            <div className="menu-tz-close" onClick={() => this.setState({ visible: false })}>&times;</div>

                            <div className="menu-tz-title">{t("timezone.title")}</div>

                            <div className="menu-tz-grid">
                                {OFFSETS.map((hours) => (
                                    <div
                                        key={hours}
                                        className={`menu-tz-item ${hours === timezone ? "active" : ""}`}
                                        onClick={() => this._apply(hours)}
                                    >
                                        <span className="menu-tz-time">{timeAt(hours)}</span>
                                        <span className="menu-tz-name">{offsetLabel(hours)}</span>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>,
                    document.body
                )}

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        timezone: state.timezone,
        language: state.language,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setTimezone: (hours) => dispatch({ type: "SET_TIMEZONE", payload: hours }),
        setLanguage: (lang) => dispatch({ type: "SET_LANGUAGE", payload: lang }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimezoneSwitcher)
